export default __webpack_public_path__ + "static/media/DocomoLogo.a79a0c87.svg";